var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _g, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayroll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#90bae1",
    d: "M59 5v38H1V5a1.944 1.944 0 012-2h54a1.944 1.944 0 012 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0d3f0",
    d: "M56 3a37.006 37.006 0 01-37 37 36.712 36.712 0 01-18-4.67V5a1.944 1.944 0 012-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    x: 9,
    y: 1,
    fill: "#ecf0f1",
    rx: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3d55b",
    d: "M29 37H14a1 1 0 01-1-1V11l6-6h17a1 1 0 011 1v7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0c419",
    d: "M19 5v5a1 1 0 01-1 1h-5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#95a5a5",
    d: "M59 43v3.82A2.1 2.1 0 0157 49H3a2.1 2.1 0 01-2-2.18V43z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7f8c8d",
    d: "M38 49l3 6H19l3-6z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 4,
    x: 13,
    y: 55,
    fill: "#95a5a5",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 26,
    x: 29,
    y: 13,
    fill: "#3b97d3",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 6,
    x: 33,
    y: 17,
    fill: "#65ddb9",
    rx: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9fc9d3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 27,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 31,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 35,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 36a1 1 0 01-1-1v-4a1 1 0 012 0v4a1 1 0 01-1 1z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f29c1f",
    d: "M24 30a3 3 0 00-3-3 1 1 0 11.867-1.5 1 1 0 001.731-1A3 3 0 0022 23.2V23a1 1 0 00-2 0v.184A2.993 2.993 0 0021 29a1 1 0 11-.867 1.5 1 1 0 10-1.731 1 3 3 0 001.6 1.3v.2a1 1 0 002 0v-.184A3 3 0 0024 30z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f5c6c",
    d: "M25 20h-8a1 1 0 010-2h8a1 1 0 010 2zm0-4h-8a1 1 0 010-2h8a1 1 0 010 2zm2-4h-4a1 1 0 010-2h4a1 1 0 010 2z"
  })));
}
export default "data:image/svg+xml;base64,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";
export { SvgPayroll as ReactComponent };